var map = {
	"./Alchimeia_island_treasure.png": "./src/assets/img/world_map/islands/with_treasure/Alchimeia_island_treasure.png",
	"./Chance_island_treasure.png": "./src/assets/img/world_map/islands/with_treasure/Chance_island_treasure.png",
	"./Fabella_island_treasure.png": "./src/assets/img/world_map/islands/with_treasure/Fabella_island_treasure.png",
	"./Judgement_island_treasure.png": "./src/assets/img/world_map/islands/with_treasure/Judgement_island_treasure.png",
	"./Lumina_island_treasure.png": "./src/assets/img/world_map/islands/with_treasure/Lumina_island_treasure.png",
	"./Morbida_island_treasure.png": "./src/assets/img/world_map/islands/with_treasure/Morbida_island_treasure.png",
	"./Oracle_island_treasure.png": "./src/assets/img/world_map/islands/with_treasure/Oracle_island_treasure.png",
	"./Solace_island_treasure.png": "./src/assets/img/world_map/islands/with_treasure/Solace_island_treasure.png",
	"./Sylva_island_treasure.png": "./src/assets/img/world_map/islands/with_treasure/Sylva_island_treasure.png",
	"./Temperus_island_treasure.png": "./src/assets/img/world_map/islands/with_treasure/Temperus_island_treasure.png",
	"./Veritas_island_treasure.png": "./src/assets/img/world_map/islands/with_treasure/Veritas_island_treasure.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/world_map/islands/with_treasure sync recursive ^\\.\\/.*_island_treasure\\.png$";